"use client";

import { useEffect, useState } from "react";
import { useTalentSearchFilters } from "@/components/search/talent-search-filters-provider";
import { useAuth } from "@/features/auth";
import {
  ClearChipsButton,
  FilterChip,
  FilterFieldContainer,
  FilterFieldContent,
  FilterFieldLabel,
} from "../shared";
import { FilterTextInput } from "@/features/search/components/filters/input/text-input";

export function FilterBooleanNameSection() {
  const { filters, updateFilter } = useTalentSearchFilters();
  const { complianceSettings } = useAuth();
  const [nameInput, setNameInput] = useState("");
  const fullNames = filters.full_names ?? [];
  const restrictNameSearch =
    complianceSettings?.candidate_name_display_mode &&
    complianceSettings.candidate_name_display_mode !== "show_all";

  useEffect(() => {
    if (restrictNameSearch && fullNames.length > 0) {
      updateFilter("full_names", undefined);
    }
  }, [fullNames.length, restrictNameSearch, updateFilter]);

  if (restrictNameSearch) {
    return (
      <FilterFieldContainer>
        <FilterFieldLabel>Full Name</FilterFieldLabel>
        <FilterFieldContent>
          <div className="rounded-md border border-border bg-surface-elevated px-3 py-2 text-xs text-muted-foreground">
            Full-name search is disabled by your organization&apos;s privacy
            settings.
          </div>
        </FilterFieldContent>
      </FilterFieldContainer>
    );
  }

  const addName = () => {
    const trimmed = nameInput.trim();
    if (!trimmed) {
      return;
    }
    updateFilter("full_names", [...fullNames, { text: trimmed, required: false }]);
    setNameInput("");
  };

  return (
    <>
      <FilterFieldContainer>
        <FilterFieldLabel>Full Name</FilterFieldLabel>
        <FilterFieldContent>
          <FilterTextInput
            value={nameInput}
            placeholder="Enter name..."
            enterHint
            onChange={setNameInput}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addName();
              }
            }}
          />
        </FilterFieldContent>
      </FilterFieldContainer>
      {fullNames.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {fullNames.map((entry, i) => {
            const excluded = entry.mode === "exclude";
            const required = entry.required ?? false;
            return (
              <FilterChip
                key={i}
                label={entry.text ?? ""}
                excluded={excluded}
                required={required}
                onToggleExclude={() => {
                  const next = [...fullNames];
                  next[i] = { ...entry, mode: excluded ? "include" : "exclude" };
                  updateFilter("full_names", next);
                }}
                onToggleRequired={() => {
                  const next = [...fullNames];
                  next[i] = { ...entry, required: !required };
                  updateFilter("full_names", next);
                }}
                onRemove={() => updateFilter("full_names", fullNames.filter((_, j) => j !== i))}
              />
            );
          })}
          <ClearChipsButton onClick={() => updateFilter("full_names", undefined)} />
        </div>
      )}
    </>
  );
}
